/* This is generated code, don't alter */
var IfcPumpTypeEnum;
(function (IfcPumpTypeEnum) {
    IfcPumpTypeEnum[IfcPumpTypeEnum["CIRCULATOR"] = 0] = "CIRCULATOR";
    IfcPumpTypeEnum[IfcPumpTypeEnum["ENDSUCTION"] = 1] = "ENDSUCTION";
    IfcPumpTypeEnum[IfcPumpTypeEnum["SPLITCASE"] = 2] = "SPLITCASE";
    IfcPumpTypeEnum[IfcPumpTypeEnum["SUBMERSIBLEPUMP"] = 3] = "SUBMERSIBLEPUMP";
    IfcPumpTypeEnum[IfcPumpTypeEnum["SUMPPUMP"] = 4] = "SUMPPUMP";
    IfcPumpTypeEnum[IfcPumpTypeEnum["VERTICALINLINE"] = 5] = "VERTICALINLINE";
    IfcPumpTypeEnum[IfcPumpTypeEnum["VERTICALTURBINE"] = 6] = "VERTICALTURBINE";
    IfcPumpTypeEnum[IfcPumpTypeEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcPumpTypeEnum[IfcPumpTypeEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcPumpTypeEnum || (IfcPumpTypeEnum = {}));
const IfcPumpTypeEnumCount = 9;
export { IfcPumpTypeEnum, IfcPumpTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcPumpTypeEnum = new Int32Array([1, -7, 53]);
let prefixSumAddressIfcPumpTypeEnum = new Uint32Array([0, 12, 22, 39, 50, 67, 83, 96, 108, 120]);
let slotMapIfcPumpTypeEnum = new Int32Array([1, 4, 6, 2, 3, 5, 7, 0, 8]);
let encodedDataIfcPumpTypeEnum = (new TextEncoder()).encode(".ENDSUCTION..SUMPPUMP..VERTICALTURBINE..SPLITCASE..SUBMERSIBLEPUMP..VERTICALINLINE..USERDEFINED..CIRCULATOR..NOTDEFINED.");
let IfcPumpTypeEnumSearch = new MinimalPerfectHash(gMapIfcPumpTypeEnum, prefixSumAddressIfcPumpTypeEnum, slotMapIfcPumpTypeEnum, encodedDataIfcPumpTypeEnum);
export { IfcPumpTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcPumpTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcPumpTypeEnumSearch, input, cursor, endCursor);
}
